import Box from "@mui/material/Box";
import DictionaryEditor from "./DictionaryEditor";
import FullScreenDialog from "./FullScreenDialog";

const DictionaryEditorDialog = ({ mainDictionary, dictionarySetter, wordToOpen, onCloseFunction }) => {
    const handleClose = () => {
        onCloseFunction()
    };
    return (
        <FullScreenDialog
            open={true}
            onClose={handleClose}
            title="Dictionary Editor"
        >
            <Box sx={{ p: 2 }}>
                <DictionaryEditor 
                    mainDictionary={mainDictionary} 
                    mainDictionarySetter={dictionarySetter} 
                    wordToOpen={wordToOpen}
                />
            </Box>
        </FullScreenDialog>
    );
};

export default DictionaryEditorDialog